export default __webpack_public_path__ + "static/GT-Super-Display-Super-7d615fcb63d3e8fe0fd8703657f4dc4a.woff";